import React from 'react'

const DashboardHeader = props => {
    return (
        <div className="bg-primary-light bg-opacity-30 p-2 text-center border border-primary rounded-lg">
            <h2 className="text-xle font-bold mb-4">{props.title}</h2>
            <div>
                {props.children}
            </div>
        </div>
    )
}


export default DashboardHeader
